import React from "react";
import styles from "./PageCard.module.scss";
import WhiteButton from "../WhiteButton/WhiteButton";

const PageCard = ({
  title,
  createdOn,
  modifiedOn,
  status,
  bordered = false,
}) => {
  return (
    <div
      className={`${styles.pageCard} ${bordered ? styles.borderDanger : styles.borderGray}`}
    >
      <div className="d-flex align-items-center justify-content-between">
        <div className="fw-semibold">{title}</div>
        <div className="d-flex gap-2">
          <WhiteButton>View Page</WhiteButton>
          <WhiteButton>Edit</WhiteButton>
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-end">
        <div>
          <div>Created on: {createdOn}</div>
          <div>Modified on: {modifiedOn}</div>
        </div>

        <div
          className={`${status.toLowerCase() === "online" ? styles.online : styles.offline}`}
        >
          {status}
        </div>
      </div>
    </div>
  );
};

export default PageCard;